import { render, staticRenderFns } from "./QuestionTab.vue?vue&type=template&id=7efcb26d"
import script from "./QuestionTab.vue?vue&type=script&lang=js"
export * from "./QuestionTab.vue?vue&type=script&lang=js"
import style0 from "./QuestionTab.vue?vue&type=style&index=0&id=7efcb26d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports